import React from 'react';
import { Card } from 'react-bootstrap';
import '../../styles/TableCard.css';

const TableCard = ({ table, handleTableClick, provided }) => {
  const cardClass = `table-card ${table.computedStatus === 'occupied' ? 'table-card--occupied' : ''} ${table.computedStatus === 'reserved' ? 'table-card--reserved' : ''} ${table.interactionMode === 'view_only' ? 'table-card--view-only' : ''}`.trim();
  const statusChipClass =
    table.computedStatus === 'occupied'
      ? 'venue-chip--danger'
      : table.computedStatus === 'reserved'
        ? 'venue-chip--info'
      : table.computedStatus === 'attention'
        ? 'venue-chip--pending'
        : table.computedStatus === 'inactive'
          ? 'venue-chip--danger'
          : 'venue-chip--neutral';
  const content = (
    <Card.Body className="table-card-body">
      <div className="table-card__header">
        <span className="table-card__eyebrow">Masa</span>
        <span className={`venue-chip ${statusChipClass}`}>
          {table.statusLabel}
        </span>
      </div>
      <Card.Title className="table-card__title">{table.name}</Card.Title>
      <div className="table-card__meta">
        <div className="table-card__meta-item">
          <span className="table-card__meta-label">Sipariş</span>
          <strong>{table.unpaidOrderCount}</strong>
        </div>
        {table.pendingRequestCount > 0 && (
          <div className="table-card__meta-item">
            <span className="table-card__meta-label">Talep</span>
            <strong>{table.pendingRequestCount}</strong>
          </div>
        )}
      </div>
    </Card.Body>
  );

  if (provided) {
    return (
      <Card
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        ref={provided.innerRef}
        onClick={() => handleTableClick(table)}
        className={cardClass}
      >
        {content}
      </Card>
    );
  }

  return (
    <Card className={cardClass} onClick={() => handleTableClick(table)}>
      {content}
    </Card>
  );
};

export default TableCard;
